export default __webpack_public_path__ + "static/media/logo_back.bc844862.jpg";